var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.903 4.767A2 2 0 015.89 3h12.222a2 2 0 011.986 1.767L21.6 17.533A4 4 0 0117.626 22H6.374A4 4 0 012.4 17.533L3.903 4.767zM18.11 5H5.89L4.386 17.767A2 2 0 006.374 20h11.252a2 2 0 001.987-2.233L18.11 5zM8 7a1 1 0 011 1 3 3 0 106 0 1 1 0 012 0A5 5 0 117 8a1 1 0 011-1z",
    fill: "#F9B035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIconYellow);
export default __webpack_public_path__ + "static/media/market-icon-yellow.43f76ad306edf89caff44df3b4a6ce16.svg";
export { ForwardRef as ReactComponent };